const LAST_RELOAD_KEY = 'staleChunkReloadAt';
// A second failure inside this window means the chunk is missing in the new build too.
const RELOAD_GUARD_MS = 10_000;

/**
 * A tab opened before a deploy still asks for the old chunk names, which the deploy removed.
 * A reload fetches the new index.html (served with no-cache) and the new chunk names.
 */
export const handlePreloadError = (): void => {
  try {
    const lastReloadAt = Number(sessionStorage.getItem(LAST_RELOAD_KEY));
    if (Date.now() - lastReloadAt < RELOAD_GUARD_MS) {
      return;
    }
    sessionStorage.setItem(LAST_RELOAD_KEY, String(Date.now()));
  } catch {
    // Without storage there is no loop guard, so let the error boundary show the error.
    return;
  }
  // No preventDefault: it would make the import() resolve to undefined and hide the real error.
  window.location.reload();
};

export const registerStaleChunkReload = (): void => {
  window.addEventListener('vite:preloadError', handlePreloadError);
};
